import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import InternalApiApp from './InternalApiApp';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
//import './index.css';

const AppWithDnd = DragDropContext(HTML5Backend)(InternalApiApp);

ReactDOM.render(<AppWithDnd/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
